import React, { useEffect, useState } from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import { Container } from "reactstrap";
import MuiButton from "../../components/muibutton";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import MuiConfirmationButton from "../../components/muiconfirmbutton";
import { getAPIwithParams, postAPI } from "../../services/basehttpAPI";
import { formatDate } from "../../utils/utils";
import * as BusinessConst from "../../utils/businessconstants";
import MuiChip from "../../components/muichip";



const ViewShipment = () => {
  const navigate = useNavigate();
  const params = useParams();
  const ShipmentDetailId = params.ShipmentDetailId;
  const DeliveryDetailId = params.DeliveryDetailId;
  const [dataList, setDataList] = useState(null);
    const [showPOD, setShowPOD] = useState(false);
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));

  const getShipmnentbyId = async () => {
    let url = "ShipmentDetails/GetShipmentDeliveryDetailsById";
    const ShipmentDetailModel = {
      ShipmentDetailId: ShipmentDetailId,
      DeliveryDetailId: DeliveryDetailId,
    };
    const response = await getAPIwithParams(url, ShipmentDetailModel);
      setDataList(response.responseData[0]);
      if (response.responseData[0].podStatusKey !== BusinessConst.POD_Open_Lookupname) {
      setShowPOD(true);
    }else{
      setShowPOD(false);
    }
  };


  const updatePODStatus = async (isConfirmed) => {
    let url = "ShipmentDetails/UpdateDeliveryDetailsPODStatus";
    const DeliveryDetailsRequestModel = {
      ShipmentDeliveryDetailsId: DeliveryDetailId,
      DeliveryId: dataList?.deliveryId,     
      IsDeliveryConfirmed: isConfirmed
    }
    await postAPI(url, DeliveryDetailsRequestModel);
    getShipmnentbyId();
  };

  useEffect(() => {
    getShipmnentbyId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownload = () => {
    const pdfFile = `data:application/pdf;base64,${dataList.podfile}`;
    let a = document.createElement('a');
    a.href = pdfFile;
    a.download = dataList.fileName;
    a.click();
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h5" flexGrow={1} sx={{ pl: "24px" }}>
              {translatedText?.my_shipments}
      </Typography>
      <Paper
        sx={{
          width: "90%",
          mt: "20px",
          ml: "20px",
          mb: "20px",
          height: (showPOD ? "28%" : "85%")
        }}
      >
        <Box sx={{ height: "60px", backgroundColor: "#F4F7FC" }}>
          <Stack
            useFlexGap
            flexWrap="wrap"
            direction="row"
            spacing={{ xs: 0.5, sm: 2, md: 3 }}
            sx={{ paddingTop: "10px", mr: "10px" }}
          >
            <IconButton onClick={() => navigate("/layout/shipments")}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h7" flexGrow={1} sx={{ pt: "5px" }}>
              {dataList?.customerOrderId} - {dataList?.indasOrderId}
            </Typography>
            <MuiConfirmationButton
                          type="button"
                          text={translatedText?.confirm_pod}//"Confirm POD"
              color="primary"
                          show={dataList?.podStatusKey !== BusinessConst.POD_Delivered_Lookupname ? false : true}
              updateStatusCallback={updatePODStatus}
            />
            {showPOD && <MuiButton
              type="button"
                          text={translatedText?.download_pod}//"Download POD"
              color="success"
              onClick={handleDownload}
                          show={dataList?.podStatusKey === BusinessConst.POD_Open_Lookupname ? false : true}
            />
            }
          </Stack>
        </Box>
        <Grid container spacing={1} sx={{ m: "20px" }}>
          <Grid item xs={12} sm={12} md={2}>
            <span className="fontcolor label-txt">{dataList?.customerOrderId ? dataList?.customerOrderId : "-"}</span>
                      <div className="fontheadercolor label-txt"> {translatedText?.customer_order_id}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={2.5}>
            <span className="fontcolor label-txt">{dataList?.indasOrderId}</span>
                      <div className="fontheadercolor label-txt">{translatedText?.indas_order_id}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={2.5}>
            <span className="fontcolor label-txt">{dataList?.deliveryId}</span>
                      <div className="fontheadercolor label-txt">{translatedText?.delivery_notes_id}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={2.5}>
                      <MuiChip row={dataList} statusKey={"deliveryStatus"}> </MuiChip>
                      <div className="fontheadercolor label-txt">{translatedText?.delivery_status}</div>
          </Grid>
                  <Grid item xs={12} sm={12} md={2}>
                      <MuiChip row={dataList} statusKey={"podStatus"}> </MuiChip>
                      <div className="fontheadercolor label-txt">{translatedText?.pod_status}</div>
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ m: "20px" }}>
          <Grid item xs={12} sm={12} md={2}>
            <span className="fontcolor label-txt">{dataList?.createdOnDate ? formatDate(dataList.createdOnDate) : " - "}</span>
                      <div className="fontheadercolor label-txt">{translatedText?.created_date}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={2}>
                      <span className="fontcolor label-txt">{dataList?.updatedOnDate ? formatDate(dataList.updatedOnDate) : " - "}</span>
                      <div className="fontheadercolor label-txt">{translatedText?.updated_date}</div>
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ m: "20px" }} alignItems="flex-end">
          <Grid item xs={12} sm={12} md={2}>            
          <div className="fontcolor label-txt">{dataList?.shipToName1}</div>  
          <div className="fontcolor label-txt">
            {(dataList?.shipToName2 == null ? "" : dataList?.shipToName2) + " " + 
          (dataList?.shipToName3 == null ? "" : dataList?.shipToName3) + " " + 
          (dataList?.shipToName4 == null ? "" : dataList?.shipToName4)} </div>
          <div className="fontcolor label-txt">{(dataList?.shipToCountry == null ? "" : dataList?.shipToCountry ) + " " +
           (dataList?.shipToCountryDesc == null ? "" : dataList?.shipToCountryDesc)}</div>
                      <div className="fontheadercolor label-txt">{translatedText?.delivery_address}</div>
          </Grid>
            <Grid item xs={12} sm={12} md={2}>            
              <div className="fontcolor label-txt">{dataList?.customShipToName ? dataList?.customShipToName : "-"}</div>
              <div className="fontheadercolor label-txt">{translatedText?.custom_ship_to_name}</div>
            </Grid>
        </Grid>
      </Paper>
      {showPOD && <Grid container sx={{ visibility: dataList?.podStatus !== BusinessConst.POD_Open_Lookupname ? 'visible' : 'hidden' }} >
        <Grid item xs={12} sm={12} md={4}>
          <Typography sx={{ mb: "20px", fontWeight: "700", ml: "20px" }}>
            POD
          </Typography>
        </Grid>
        <Box sx={{
          width: "100%",
          height: "800px",
          ml: "20px"
        }}>
          <embed
            src={`data:application/pdf;base64,${dataList?.podfile}#toolbar=0&navpanes=0`}
            id="podFile"
            width="90%"
            height="100%"
            style={{ borderStyle: "solid" }}
            type="application/pdf"
          />
        </Box>
      </Grid>}
    </Container>
  );
}

export default ViewShipment;
